/* The Supabase client for the public pages. Same project and env vars as the app
   (VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY, inlined by Vite at build time).
   Returns null when they're missing (a local build without app/.env), so pages can say so
   instead of throwing. */
import { createClient } from "@supabase/supabase-js";

export var SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export var SUPABASE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

/* anonymous: for forms on public pages. Doesn't read, refresh or store the visitor's session. */
export function anonClient(){
  if(!SUPABASE_URL || !SUPABASE_KEY) return null;
  return createClient(SUPABASE_URL, SUPABASE_KEY, {
    auth: {persistSession: false, autoRefreshToken: false, detectSessionInUrl: false}
  });
}

/* signed-in: shares the app's stored session (same origin), for /admin */
export function sessionClient(){
  if(!SUPABASE_URL || !SUPABASE_KEY) return null;
  return createClient(SUPABASE_URL, SUPABASE_KEY);
}

/* the RPC or table isn't there yet (migration not run): PostgREST's "not found in schema cache" */
export function isMissing(err, status){
  if(!err) return false;
  var c = err.code || "";
  return c === "PGRST202" || c === "PGRST205" || c === "42P01" || c === "42883" || status === 404;
}

/* the request never reached the server */
export function isOffline(err, status){
  if(typeof navigator !== "undefined" && navigator.onLine === false) return true;
  if(!err) return false;
  var m = String(err.message || err);
  return status === 0 || /failed to fetch|networkerror|network request failed|load failed|fetch failed/i.test(m);
}
